import * as React from 'react';

function BeerPouring1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={64}
      id="beer-pouring-1"
      height={130}
      fill="none"
      viewBox="0 0 64 130"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.088 2.47H63.28c.545 50.866-22.736 101.7-11.819 125.233A2.313 2.313 0 0149.157 130H14.21a2.312 2.312 0 01-2.302-2.297C22.826 104.17-.455 53.336.089 2.469z"
        fill="#C0BFBF"
      />
      <path
        d="M2.25 4.438h58.875c0 52.421-17.945 87.162-13.459 115.412H15.71C20.195 91.6 2.25 56.86 2.25 4.438z"
        fill="#D4D4D4"
      />
      <path
        d="M29.294 94.464a2.384 2.384 0 002.387 2.382c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38a2.384 2.384 0 00-2.387 2.38z"
        fill="#D4D4D4"
      />
      <path
        d="M43.65 59.911a3.124 3.124 0 003.128 3.118 3.123 3.123 0 003.128-3.118c0-1.724-1.399-3.12-3.128-3.12a3.125 3.125 0 00-3.129 3.12z"
        fill="#F8F8F8"
      />
      <path
        d="M31.684 130h17.472a2.313 2.313 0 002.305-2.297c-2.08-4.482-2.92-9.952-2.917-16.227.002-26.281 14.741-66.636 14.745-107.218 0-.597-.004-1.192-.01-1.789H31.684v1.968H61.12c0 52.422-17.945 87.162-13.459 115.412H31.684V130z"
        fill="#999"
      />
      <path
        d="M31.688 119.85h15.978C43.18 91.6 61.125 56.86 61.125 4.438H31.688v87.647c1.32 0 2.389 1.065 2.389 2.38a2.385 2.385 0 01-2.39 2.381v23.004zm15.095-63.062a3.123 3.123 0 013.128 3.12c0 1.723-1.399 3.12-3.128 3.12a3.124 3.124 0 01-3.129-3.12 3.125 3.125 0 013.129-3.12z"
        fill="#D4D4D4"
      />
      <path
        d="M31.68 96.846c1.321 0 2.39-1.066 2.39-2.382 0-1.314-1.069-2.38-2.39-2.38v4.762zM46.778 63.03a3.123 3.123 0 003.128-3.119c0-1.724-1.399-3.12-3.128-3.12a3.125 3.125 0 00-3.129 3.12 3.124 3.124 0 003.129 3.118z"
        fill="#D4D4D4"
      />
      <path
        d="M9.23 5.543H3.826c-.691 32.6 15.105 75.56 14.275 113.409C21.148 67.704 8.596 53.85 9.23 5.543z"
        fill="#F8F8F8"
      />
      <path
        d="M42.625 41.268c0 1.745.93 3.16 2.077 3.16 1.148 0 2.08-1.415 2.08-3.16 0-1.746-.932-3.16-2.08-3.16-1.146 0-2.077 1.414-2.077 3.16zM19.014 35.778a3.125 3.125 0 003.13 3.118 3.124 3.124 0 003.13-3.118 3.125 3.125 0 00-3.13-3.12 3.125 3.125 0 00-3.13 3.12zM20.007 25.023a4.193 4.193 0 004.2 4.186c2.32 0 4.2-1.874 4.2-4.186 0-2.311-1.88-4.187-4.2-4.187a4.195 4.195 0 00-4.2 4.187z"
        fill="#D4D4D4"
      />
      <ellipse cx={31.744} cy={3.277} rx={31.744} ry={3.277} fill="#F8F8F8" />
      <path
        d="M45.701 114.188s3.124-6.824-1.452-9.668c-8.797-.522-6.063.939-9.927 1.359-2.438.265-4.456 1.182-6.398 1.13-5.319-.146-7.105-.725-10.161 1.129-3.026 2.558-.534 6.05-.534 6.05h28.472z"
        fill="#F8F8F8"
      />
      <path
        d="M16.423 112.305c0 1.798-.73 5.993-1.095 7.866h32.839l-1.095-7.866s-5.473-1.966-15.325 0c-9.851 1.966-15.324 0-15.324 0z"
        fill="url(#prefix__paint0_linear_14338_42014)"
      />
      <path d="M20.02 118.3a1.129 1.129 0 100-2.258 1.129 1.129 0 000 2.258z" fill="#F8F8F8" />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14338_42014"
          x1={48.248}
          y1={116.041}
          x2={15.128}
          y2={116.041}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset={1} stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default BeerPouring1;
